import { ACCOUNT_STATEMENT, ALL_GATEWAYS, SELECTED_GATEWAY } from "./types";
import { API_URLS } from "../../config/apiUrls";
import { axiosService } from "../../utils/axiosService";
import { Toaster } from "../../utils/toaster";
import { APP_CONST } from "../../config/const";
import axios, { AxiosError } from "axios";
export const getAccountStatement = (data) => (dispatch) => {
  try {
    const result = axiosService.get(
      `${API_URLS.USER.ACCOUNT_STATEMENT}/${data?.from}/${data?.to}`
    );
    result
      .then((res) => {
        dispatch({
          type: ACCOUNT_STATEMENT,
          payload: res.data.data.transactions,
        });
      })
      .catch((err) => {
        console.log(err);
        Toaster(APP_CONST.TOAST_TYPE.ERROR, err?.response?.data?.message);
      });
  } catch (err) {
    console.debug(err);
  }
};

// send withdraw request
// POST

export const createWithDrawRequest = async (payload) => {
  try {
    const result = await axiosService.post(
      API_URLS.USER.CREATE_WITHDRAW_REQUEST,
      payload
    );
    return result;
  } catch (err) {
    console.debug(err);
    Toaster(APP_CONST.TOAST_TYPE.ERROR, err.response.data.message);
  }
};

// despoit create
//POST

// export const createDeposit = (payload) => (dispatch) => {
//   try {
//     const result = axiosService.post(API_URLS.USER.CREATE_DEPOSIT, payload, {
//       headers: {
//         "Content-Type": `multipart/form-data`,
//       },
//     });
//     return result;
//   } catch (err) {
//     console.debug(err);
//   }
// };

export const createDeposit = async (payload) => {
  try {
    const result = await axiosService.post(
      API_URLS.USER.CREATE_DEPOSIT,
      payload,
      {
        headers: {
          "Content-Type": `multipart/form-data`,
        },
      }
    );
    return result;
  } catch (err) {
    console.log(err);
    if (err instanceof AxiosError) {
      Toaster(
        APP_CONST.TOAST_TYPE.ERROR,
        err.response.data?.message || "Failed to create request"
      );
    }
  }
};
// floxy payment url

export const getOnlinePaymentLink = async (data) => {
  try {
    const result = await axiosService.post(API_URLS.USER.FLOXY_DEPOSIT, data);
    if (result.data && result?.data?.data?.data) {
      return result.data.data.data;
    }

    return null;
  } catch (err) {
    if (err instanceof AxiosError) {
      Toaster(
        APP_CONST.TOAST_TYPE.ERROR,
        err.response.data?.error?.message || "Failed to create payment"
      );
    }
    // console.debug(err);
    return null;
  }
};

// hpay
export const getHpayPaymentLink = async (data) => {
  try {
    const result = await axiosService.post(API_URLS.USER.HPAY_DEPOST, data);
    if (result.data && result?.data?.data?.data) {
      return result.data.data.data;
    }
  } catch (err) {
    if (err instanceof AxiosError) {
      Toaster(
        APP_CONST.TOAST_TYPE.ERROR,
        err.response.data?.error?.message || "Failed to create payment"
      );
    }
    // console.debug(err);
    return null;
  }
};

/**
 * @param {*} payload { name: "", walletNo: "", amount: 0,  txnId: "", gateway:"" };
 * @returns
 */
export const createDepositRequestHandler = async (payload) => {
  // console.log({
  //   payload,
  // });
  try {
    return axiosService.post(API_URLS.USER.CREATE_DEPOSIT, payload);
  } catch (err) {
    Toaster(APP_CONST.TOAST_TYPE.ERROR, err.response.data.message);
    console.debug(err);
  }
};

// binancepay
export const getBinancePay = async (data) => {
  try {
    const result = await axiosService.post(
      API_URLS.USER.BINANCE_PAY_DEPOSIT,
      data
    );
    if (result.data && result?.data?.data?.data) {
      return result.data.data.data;
    }
  } catch (err) {
    if (err instanceof AxiosError) {
      Toaster(
        APP_CONST.TOAST_TYPE.ERROR,
        err.response.data?.error?.message || "Failed to create payment"
      );
    }
    // console.debug(err);
    return null;
  }
};

// hpay
export const getCoinBasePayment = async (data) => {
  try {
    const result = await axiosService.post(
      API_URLS.USER.COIN_BASE_DEPOSIT,
      data
    );
    if (result.data && result?.data?.data?.data) {
      return result.data.data.data;
    }
  } catch (err) {
    if (err instanceof AxiosError) {
      Toaster(
        APP_CONST.TOAST_TYPE.ERROR,
        err.response.data.message || "Failed to create payment"
      );
    }
    // console.debug(err);
    return null;
  }
};

// update user email

export const updateUserEmail = async (payload) => {
  try {
    const result = await axiosService.post(
      API_URLS.USER.UPDATE_USER_EMAIL,
      payload
    );

    return result;
  } catch (err) {
    if (err instanceof AxiosError) {
      Toaster(
        APP_CONST.TOAST_TYPE.ERROR,
        err.response.data.message || "Failed to update email"
      );
    }
    return null;
  }
};

export const updateDepositAmount = async (payload) => {
  try {
    let headers = {};
    console.log("payload", payload);
    if (payload?.isMultiPart == true) {
      headers["Content-Type"] = `multipart/form-data`;
    }
    const result = await axiosService.post(payload.url, payload.data, {
      headers,
    });
    return result;
  } catch (err) {
    if (err instanceof AxiosError) {
      Toaster(
        APP_CONST.TOAST_TYPE.ERROR,
        err?.response?.data?.message || "Payment Failed"
      );
    }
    console.debug(err);
  }
};

export const getAllGateways = () => (dispatch) => {
  try {
    const result = axiosService.get(API_URLS.USER.GET_ALL_GATEWAYS);
    result.then((res) => {
      dispatch({
        type: ALL_GATEWAYS,
        payload: res.data.data.data,
      });
    });
  } catch (err) {
    if (err instanceof AxiosError) {
      Toaster(
        APP_CONST.TOAST_TYPE.ERROR,
        err.response.data?.error?.message || "Failed to get gateways"
      );
    }
  }
};

export const setSelectedGateway = (payload) => (dispatch) => {
  dispatch({
    type: SELECTED_GATEWAY,
    payload: payload,
  });
};
